import routesAnonymous from 'app/routes/anonymous';
export const routes = routesAnonymous;
